import React from 'react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="border-t border-slate-800/30 bg-navy-950 py-12" data-id="element-81">
      <div className="max-w-7xl mx-auto px-6" data-id="element-82">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-10" data-id="element-83">
          <div className="text-xl font-bold text-white" data-id="element-84">Pulsewave</div>

          <div className="flex items-center gap-8" data-id="element-85">
            <button onClick={() => scrollToSection('how-it-works')} className="text-slate-400 hover:text-white transition-colors text-sm font-medium" data-id="element-86">
              How it works
            </button>
            <button onClick={() => scrollToSection('program')} className="text-slate-400 hover:text-white transition-colors text-sm font-medium" data-id="element-87">
              Creator Lab
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-slate-400 hover:text-white transition-colors text-sm font-medium" data-id="element-88">
              FAQ
            </button>
          </div>

          <a href="mailto:hello@pulsewaveco.com" className="text-slate-400 hover:text-white transition-colors text-sm font-medium" data-id="element-89">
            hello@pulsewaveco.com
          </a>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-slate-800/20 text-sm text-slate-500" data-id="element-90">
          <div data-id="element-91">© Pulsewave {new Date().getFullYear()}</div>
          <div className="flex gap-6" data-id="element-92">
            <a href="/privacy" onClick={e => {
            e.preventDefault();
            window.location.hash = 'privacy';
          }} className="hover:text-slate-300 transition-colors" data-id="element-93">
              Privacy
            </a>
            <a href="/terms" onClick={e => {
            e.preventDefault();
            window.location.hash = 'terms';
          }} className="hover:text-slate-300 transition-colors" data-id="element-94">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}